import React, { useEffect } from "react";
import Hero from "../components/sections/Hero";
import About from "../components/sections/About";
import Menu from "../components/sections/Menu";
import ScrollIndicator from "../components/ui/ScrollIndicator";
import OpeningHoursPublic from "../components/sections/OpeningHoursPublic";


const Home = () => {
  useEffect(() => {
    document.title = "Golden Arm | Premium Dining Experience";
  }, []);

  return (
    <div>
      <ScrollIndicator />
      <Hero />
      <About />
      <Menu />
      <OpeningHoursPublic />
    </div>
  );
};

export default Home;
